import { MAP_CENTER, MAP_LIMIT, MAP_MIN_ZOOM } from './map'

import type { Position } from '@xleddyl/types'

export const mapIcons = {
   location: '/images/map/location.png',
   locationDisabled: '/images/map/location-disabled.png',
   locationForbidden: '/images/map/location-forbidden.png',
   locationCluster: '/images/map/location-cluster.png',
   poiForbidden: '/images/map/poi-forbidden.png',
   poiParking: '/images/map/poi-parking.png',
   poiPath: '/images/map/poi-path.png',
   poiWebcam: '/images/map/poi-webcam.png',
   poiWarning: '/images/map/poi-warning.png',
   poiInfo: '/images/map/poi-info.png',
}

export const mapConfig = {
   center: MAP_CENTER as [number, number],
   limit: MAP_LIMIT as [Position, Position],
   minZoom: MAP_MIN_ZOOM,
   primary: '#0d4631',
   secondary: '#bde68f',
}
